var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_13865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9649 18.5581L26.954 18.5472L21.4415 13.0308C21.4415 13.0308 14.7227 19.7495 11.4852 23.0542C11.0821 23.4651 10.7766 24.037 10.5954 24.5901C10.0641 26.2144 9.62427 27.8714 9.13521 29.512C9.00396 29.9519 9.03052 30.3394 9.37505 30.6675C9.70005 30.98 10.0657 30.9909 10.4876 30.8644C12.0501 30.3956 13.6227 29.9495 15.1922 29.5003C15.9993 29.2664 16.731 28.8249 17.3141 28.2198C20.3985 25.1167 26.9649 18.5581 26.9649 18.5581Z",
    fill: "#060200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1828 11.704L28.2976 9.81882C27.8142 9.33579 27.1587 9.06445 26.4753 9.06445C25.7919 9.06445 25.1365 9.33579 24.6531 9.81882L22.5164 11.9532L28.0468 17.4852L30.1835 15.3485C30.6665 14.865 30.9377 14.2095 30.9375 13.5261C30.9374 12.8427 30.6659 12.1873 30.1828 11.704Z",
    fill: "#060200"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_13865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpen);
export default __webpack_public_path__ + "static/media/Editpen.cece6f7b2027fc58f5bf0dc030fc37c6.svg";
export { ForwardRef as ReactComponent };